(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function (parent) {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations'),
        productRecommendationsSectionGrid = productRecommendationsSection.querySelector('.product-grid');

    if (productRecommendationsSectionGrid === null) {
      return;
    }
    
    // Hide the product recommendations section initially
    productRecommendationsSection.style.display = 'none';

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", parent.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        const response = JSON.parse(request.response),
              c_products = response.products,
              card_template = productRecommendationsSection.querySelector('#product-card-template');

        // Clear any existing content
        productRecommendationsSectionGrid.innerHTML = '';

        if (c_products.length > 0) {
          c_products.forEach(product => {
            const product_recommendation_card = card_template.content.cloneNode(true),
                  linkTags = product_recommendation_card.querySelectorAll('.product-link');
            linkTags.forEach((linkTag) => {
                linkTag.href = product.url;
            });
            product_recommendation_card.querySelector('.product-block__image img').src = product.featured_image;
            product_recommendation_card.querySelector('.product-block__image img').alt = product.title;
            product_recommendation_card.querySelector('.product-block__title').textContent = product.title;
            product_recommendation_card.querySelector('.price__current').remove();
            productRecommendationsSectionGrid.appendChild(product_recommendation_card);
          });
          // Show the section if there are products
          productRecommendationsSection.style.display = 'block';
        }
      }
    };
    request.send();
  };

  // fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations for each product on page load
  var recommendationParents = document.querySelectorAll('[data-recommendations-parent]');
  recommendationParents.forEach((parent) => {
    loadProductRecommendationsIntoSection(parent);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
